<template>
  <div class="hero is-primary section-project-list" id="section-project-list">
    <div class="hero-body">
      <!-- <div-container>
        <div style="text-align:center;">
          <h1 class="title">showcase</h1>
        </div>
      </div-container> -->
      <div style="text-align:center;width:100%;">
        <gallery-dynamix></gallery-dynamix>
      </div>
      <div style="text-align:center;width:100%;display:none;">
        <h1 class="title">web works</h1>
        <ul>
          <li v-for="work in workList" style="margin-bottom:3em;">
            <a :href="work.link" target="_blank">
              <h2 style="margin-bottom:1em;">{{ work.name }}</h2>
              <img :src="work.logo" data-pin-nopin="true" style="max-width:240px;padding:15px;border-radius:3px;background-color:rgba(255,255,255,0.7);" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import DivContainer from './DivContainer'
  import DivColumns from './DivColumns'
  import GalleryDynamix from './GalleryDynamix'
  import LogoAdamLobo from '../assets/project_logo_adamlobo.svg'
  import LogoIdlyCity from '../assets/project_logo_idlycity.svg'
  import LogoShopify from '../assets/project_logo_lastingimpressions.svg'
  import LogoIcmarc from '../assets/project_logo_icmarc.png'
  import LogoVr from '../assets/project_logo_vr.png'
  export default {
    name: 'section-project-list',
    components: {
      DivContainer,
      DivColumns,
      GalleryDynamix
    },
    data () {
      return {
        quoteContent: '',
        workList: [{
          name: 'Adam Lobo',
          link: 'http://adamlobo.tv',
          logo: LogoAdamLobo
        }, {
          name: 'Idly City',
          link: 'https://idlycity.noctorus.studio',
          logo: LogoIdlyCity
        }, {
          name: 'Shopify Setup',
          link: 'http://shop.lasting-impressions.com.my',
          logo: LogoShopify
        }, {
          name: 'Web Game',
          link: 'https://icmarc.noctorus.studio/',
          logo: LogoIcmarc
        }, {
          name: 'VR',
          link: 'https://vrcard.noctorus.studio/',
          logo: LogoVr
        }]
      }
    },
    computed: {
    },
    created () {
    },
    mounted () {
    },
    methods: {
    }
  }
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.section-project-list {
  transition: visibility 0s linear 0s,opacity .4s 0s;
  background-color: $color-gray;

  .hero-body {
    color: #cccccc;
    padding-top: 0em;
    padding-bottom: 0em;
    padding-left: 0;
    padding-right: 0;

    .title {
      color: #CCCCCC;
      margin-top: 5em;
      margin-bottom: 3em;
    }

    a > h1, h2, h3, h4, h5, h6 {
      font-family: $font-family;
      font-weight: 300;
    }
  }
}

</style>



// WEBPACK FOOTER //
// ContentProjectListSection.vue?461d5a1e